module.exports = __webpack_public_path__ + "img/icon_youxuanhui.32efaf1d.svg";